import { render, staticRenderFns } from "./ScreeningTrendMatrix.vue?vue&type=template&id=98828c2c&scoped=true&"
import script from "./ScreeningTrendMatrix.vue?vue&type=script&lang=js&"
export * from "./ScreeningTrendMatrix.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningTrendMatrix.vue?vue&type=style&index=0&id=98828c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98828c2c",
  null
  
)

export default component.exports